import { Component, ChangeDetectorRef } from '@angular/core';
import { FormGroup, Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { LoginService } from '@core/services/login/login.service';
import { ToastrService } from '@core/services/notification/toastr.service';
import { UtilityService } from '@core/services/util/utility.service';
import { StorageService } from '@core/services/util/storage.service';
import { PonchoUIModule } from '@poncho/ui';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-main-forgot-password',
    templateUrl: './main-forgot-password.component.html',
    styleUrls: ['./main-forgot-password.component.scss'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, PonchoUIModule]
})
export class MainForgotPasswordComponent {
    mobileNumber: string;
    resetPassword: FormGroup;
    btnLoading = false;
    enableResendOtp = false;
    timeDelay: any;
    timerInterval: any;

    constructor(
        private loginService: LoginService,
        private toastrService: ToastrService,
        private authenticationService: AuthenticationService,
        private utilityService: UtilityService,
        private storageService: StorageService,
        private cdr: ChangeDetectorRef
    ) {
        this.mobileNumber = this.storageService.get('phone_number');
        this.resetPassword = new FormGroup({
            code: new FormControl(''),
            password: new FormControl('', Validators.compose([Validators.minLength(6)])),
            confirm_password: new FormControl('')
        }, { validators: this.passwordMatchValidator });
        this.initiateTimer();
    }

    passwordMatchValidator(formGroup: FormGroup): { [key: string]: boolean } | null {
        const passwordControl = formGroup.get('password');
        const confirmPasswordControl = formGroup.get('confirm_password');

        if (!passwordControl || !confirmPasswordControl) {
            return null;
        }
    
        if (confirmPasswordControl.errors && !confirmPasswordControl.errors['passwordMismatch']) {
            return null;
        }
    
        if (passwordControl.value !== confirmPasswordControl.value) {
            confirmPasswordControl.setErrors({ passwordMismatch: true });
            return { passwordMismatch: true };
        } else {
            confirmPasswordControl.setErrors(null);
            return null;
        }
    }

    resendVerificationCode() {
        if (this.enableResendOtp) {
            this.initiateTimer();
            this.enableResendOtp = false;
            this.btnLoading = true;
            this.loginService
                .initiateResetPassword()
                .toPromise()
                .then((data: any) => {
                    if (data && data.meta) {
                        // this.btnLoading = false;
                        this.toastrService.openSnackBar(data.meta.message, 'OKAY');
                    }
                })
                .catch((error: any) => {
                    this.toastrService.openSnackBar(error?.meta?.message, 'OKAY');
                })
                .finally(() => {
                    this.btnLoading = false;
                    this.cdr.markForCheck();
                });
        }
    }

    initiateTimer() {
        this.timeDelay = 30;
        clearInterval(this.timerInterval);

        this.timerInterval = setInterval(() => {
            this.timeDelay = Number(this.timeDelay);
            if (this.timeDelay > 0) {
                this.timeDelay--;
                this.timeDelay = this.timeDelay < 10 ? '0' + this.timeDelay : this.timeDelay;
            } else {
                this.enableResendOtp = true;
                clearInterval(this.timerInterval);
            }
            this.cdr.markForCheck();
        }, 1000);
    }

    reset() {
        if (!this.resetPassword.valid) {
            this.utilityService.markFormFieldsAsTouched(this.resetPassword);
            return;
        }

        this.btnLoading = true;
        this.loginService.ensureSessionId().then(() => {
            const code = String(this.resetPassword.get('code').value);
            const password = this.resetPassword.get('password').value;
            const confirm_password = this.resetPassword.get('confirm_password').value;

            this.loginService
                .resetPassword(password, confirm_password, code)
                .toPromise()
                .then((data: any) => {
                    if (data && data.meta) {
                        if (data.meta.code === 200) {
                            this.authenticationService.step.next('signin');
                            this.authenticationService.mobileStep.next('login-with-password');
                            this.toastrService.openSnackBar(data.meta.message, 'OKAY');
                        } else {
                            this.toastrService.openSnackBar(data.meta.message, 'OKAY');
                        }
                    }
                })
                .catch((error: any) => {
                    this.toastrService.openSnackBar(error?.meta?.message, 'OKAY');
                })
                .finally(() => {
                    this.btnLoading = false;
                    this.cdr.markForCheck();
                });
        });
    }

    allowOnlyNumbers(event: KeyboardEvent | ClipboardEvent): boolean {
        return this.utilityService.allowOnlyNumbers(event);
    }
}
